import type { StaticImageData } from "next/image";
import item1 from "./visuals/creator-strategy.png";
import item2 from "./visuals/identify-creators.png";
import item3 from "./visuals/develop-briefs.png";
import item4 from "./visuals/connect-creators.png";
import item5 from "./visuals/deliver-campaigns.png";

export type CampaignDeliveryStep = {
  number: string;
  label: string;
  image: StaticImageData;
};

export const CAMPAIGN_DELIVERY_STEPS: CampaignDeliveryStep[] = [
  { number: "01", label: "Write bullet proof strategy", image: item1 },
  { number: "02", label: "Identify the right creators", image: item2 },
  { number: "03", label: "Develop killer briefs", image: item3 },
  { number: "04", label: "Connect with creators", image: item4 },
  { number: "05", label: "Deliver smooth campaigns", image: item5 },
];
